/* eslint-disable max-lines-per-function, camelcase */

const createBannerElement = (banner) => {
	return {
		content: banner.value,
		isInlineBanner: true,
		uid: 'ssib-' + banner.config.position.index
	};
};

export const updateResults = () => async draftSearchData => {
	let updatedResults = {};
	const resultsToUpdate = [];
	const pushedImpressions = [];
	let impressionArray = [];
	let gtmItemList = '';

	if (window.mivaJS.Screen === 'SRCH') {
		gtmItemList = 'search_results';
	}

	for (let result of draftSearchData.results) {
		if (!updatedResults[result.uid]) {
			resultsToUpdate.push(result.uid);
		}
	}

	if (resultsToUpdate.length) {
		// Make runtime api request to load product pricing and inventory
		const response = await fetch(
			window.mivaJS.Json_Url,
			{
				body: JSON.stringify({
					Filter: [
						{
							Name: 'ondemandcolumns',
							Value: [
								'CustomField_Values:customfields:variant_price_range',
								'inventory',
								'sale_price'
							]
						},
						{
							Name: 'search',
							Value: [
								{
									Field: 'code',
									Operator: 'IN',
									Value: resultsToUpdate
								}
							]
						}
					],
					Function: 'Runtime_ProductList_Load_Query',
					Session_Type: 'runtime',
					Store_Code: window.mivaJS.Store_Code
				}),
				headers: {
					'Content-Type': 'application/json'
				},
				method: 'POST'
			}
		);

		const jsonResponse = await response.json();

		// Create a unique dict of update data
		if (jsonResponse.success) {
			const products = jsonResponse.data.data;

			for (let product of products) {
				updatedResults[product.code] = {
					base_price: product.base_price,
					inventory_active: product.inv_active,
					inventory_count: product.inv_available,
					inventory_level: product.inv_level,
					price: product.price,
					retail: product.retail,
					variant_price_range: product.CustomField_Values?.customfields?.variant_price_range ?? ''
				};
			}
		}
	}

	// Mesh update data into results data
	draftSearchData.results = draftSearchData.results.map(result => {
		const updatedResult = {
			...result,
			...updatedResults[result.uid]
		};

		if (!pushedImpressions.includes(updatedResult.uid)) {
			pushedImpressions.push(updatedResult.uid);

			impressionArray.push({
				brand: updatedResult.brand ?? '',
				id: updatedResult.uid ?? '',
				item_brand: updatedResult.brand ?? '',
				item_id: updatedResult.uid ?? '',
				item_list_id: gtmItemList ? gtmItemList.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') : '',
				item_list_name: gtmItemList ?? '',
				item_name: updatedResult.name ?? '',
				name: updatedResult.name ?? '',
				price: updatedResult.price
			});
		}

		return updatedResult;

	});

	if (typeof window.dataLayer !== 'undefined' && impressionArray.length) {
		// Clear out previous ecommerce object
		window.dataLayer.push({
			ecommerce: null
		});

		window.dataLayer.push({
			ecommerce: {
				currencyCode: window.mivaJS.Currency_Code ?? 'USD',
				impressions: impressionArray
			},
			event: 'impressions',
			ga_event_action: 'Impressions',
			ga_event_category: 'Ecommerce',
			ga_event_label: '',
			ga_event_noninteraction_hit: true,
			ga_event_value: ''
		});
	}

	return draftSearchData;
};

export const insertInlineBanners = () => draftSearchData => {
	const merchandisingContent = draftSearchData?.merchandising?.content ? draftSearchData.merchandising.content : {};
	const inlineBanners = merchandisingContent.inline ? Array.from(merchandisingContent.inline) : [];

	if (!inlineBanners.length) {
		return draftSearchData;
	}

	const tailBanners = [];
	const pageBegin = draftSearchData.pagination.begin - 1;
	const pageEnd = draftSearchData.pagination.end;

	inlineBanners
		.filter((banner) => {
			const bannerElement = createBannerElement(banner);
			const bannerPosition = banner.config.position.index;

			if (bannerPosition >= pageBegin) {
				if (bannerPosition <= pageEnd - 1) {
					return true;
				}
				tailBanners.push(bannerElement);
			}

			return false;
		})
		.forEach((banner) => {
			const bannerElement = createBannerElement(banner);
			draftSearchData.results.splice(banner.config.position.index - pageBegin, 0, bannerElement);
		});

	return draftSearchData;
};

export const insertFacetOptionOverflows = () => draftSearchData => {
	const facets = draftSearchData?.facets ? Array.from(draftSearchData.facets) : [];

	if (!facets.length) {
		return draftSearchData;
	}

	facets.forEach((facet, index) => {
		if (facet.overflow) {
			return;
		}

		const remainingFacetValues = facet.values.length > 7 ? facet.values.length - 7 : '';
		const defaultOverflow = {
			$active: false,
			limit: 7,
			remaining: remainingFacetValues
		};

		draftSearchData.facets[index].overflow = defaultOverflow;
	});

	return draftSearchData;
};
